import { useMemo } from 'react';

import useAddModuleFromTemplate from '~hooks/useAddModuleFromTemplate';
import { getEntityDefinition } from '~services/entity-definitions';

type ModuleTemplateProps = {
  entityType: string;
  parentContext: string;
  index?: number;
  onChooseItem: () => void;
};

export function ModuleItem({ entityType, parentContext, index, onChooseItem }: ModuleTemplateProps) {
  const addModule = useAddModuleFromTemplate({ parentId: parentContext });

  const [name, icon] = useMemo(() => {
    const entityDef = getEntityDefinition(entityType);
    return [entityDef.meta.name, `c-icon-custom--${entityDef.meta.iconName}`];
  }, [entityType]);

  const handleOnClick = () => {
    onChooseItem();
    addModule(entityType, index);
  };

  return (
    <div
      className="bg-white m-1 h-16 cursor-pointer flex align-items-center flex-column justify-center"
      onClick={handleOnClick}
    >
      <div>
        <i className={`c-icon-custom ${icon}  text-3xl`} />
      </div>
      <div className={`text-center`}>{name}</div>
    </div>
  );
}
